<div [formGroup]="Form">
  <div class="form-row">
    <div [ngClass]="{ 'form-floating col-md-6': !SeparateRow, 'form-floating col-md-12 mb-3': SeparateRow }">
      <select
        (change)="this.getRegionsByCountry($event.target.value)"
        id="Country"
        class="form-control"
        name="Country"
        formControlName="Country"
        [ngClass]="{ 'is-invalid': HasSubmitted && !!Form.controls.Country.errors }"
        required
      >
        <option *ngFor="let country of countryOptions" [value]="country.CountryName">
          {{ country.DisplayName }}
        </option>
      </select>
      <label class="mb-2" for="Country">{{ 'country.and.regions.country' | translate }}</label>
      <div class="invalid-feedback">
        {{ 'country.and.regions.country.invalid' | translate : { fgbdefault: 'Please select a country' } }}
      </div>
    </div>
    <div [ngClass]="{ 'form-floating col-md-6': !SeparateRow, 'form-floating col-md-12 mb-3': SeparateRow }">
      <select
        *ngIf="regionOptions.length > 1"
        id="County"
        class="form-control"
        name="County"
        type="text"
        formControlName="County"
        [ngClass]="{ 'is-invalid': HasSubmitted && !!Form.controls.County.errors }"
        required
      >
        <option value="" selected disabled hidden>--select--</option>
        <option *ngFor="let region of regionOptions" value="{{ region.RegionName }}">
          {{ region.DisplayName }}
        </option>
      </select>

      <input
        *ngIf="regionOptions[0] == null"
        id="County"
        class="form-control"
        name="County"
        type="text"
        formControlName="County"
        [ngClass]="{ 'is-invalid': HasSubmitted && !!Form.controls.County.errors }"
        required
      />
      <label class="mb-2" for="County">{{ 'country.and.regions.county' | translate }}</label>
      <div *ngIf="regionOptions.length > 1" class="invalid-feedback">Please select a {{ RegionLabel.toLowerCase() }}</div>
      <div *ngIf="regionOptions[0] == null" class="invalid-feedback">Please enter a {{ RegionLabel.toLowerCase() }}</div>
    </div>
  </div>
</div>
